import { Reducer } from 'redux';
import { initialResponseState, IResponseState } from '../state';
import { SendReportActions, SendReportTypes } from './sendReport.type';
import { GlobalReducer } from '../app';

export const SendReportReducer: Reducer<IResponseState, SendReportActions> = (
	state = initialResponseState,
	action: SendReportActions,
) => GlobalReducer(state, action, SendReportTypes.SEND_REPORT.toString());
